import React from "react";
import "./PortfolioCard.scss";
import { useDataContext } from "../../../../contexts/Context";

export default function PortfolioCard({ name, index, site }) {
  const { img, setImg, setProject } = useDataContext();
  const handleClick = (e) => {
    setImg(e.target.id);
    setProject(e.target.id.charAt(0).toUpperCase() + e.target.id.slice(1));
  };
  return (
    <div
      style={{
        position: "relative",
        width: "23vh",
        height: "27vh",
        marginTop: (index === 2 && "10vh") || (index === 3 && "-10vh"),
      }}
      onClick={handleClick}
    >
      <div className="portfolio-card" id={name.toLowerCase()}>
        {name.charAt(0).toUpperCase() + name.slice(1)}
      </div>
      <div
        className="portfolio-card-hover"
        style={{ opacity: img === name.toLowerCase() ? 1 : 0 }}
      ></div>
    </div>
  );
}
